// extracted by mini-css-extract-plugin
export var blockClass = "PlainText-module--blockClass--wUovi";
export var containerClass = "PlainText-module--containerClass--lBjIq";
export var textBlockClass = "PlainText-module--textBlockClass--xpgyr";
export var innerWrapperClass = "PlainText-module--innerWrapperClass--bDq2V";